<div class="tile hud-tile" (click)="onContextMenuSelect({ text: 'View Data' })">
  <div class="metric-card">
    <div class="metric-header">
      <h3>Mean Time to Disposition</h3>
    </div>
    <!-- Use partnerMttd data if available, otherwise fall back to the old inputs -->
    <div class="metric-value">{{ partnerMttd().average_mttd_minutes_current !== null ? partnerMttd().average_mttd_minutes_current : 0 }} mins</div>
    <div
      class="metric-comparison"
      [class.up]="(partnerMttd().average_mttd_minutes_current !== null ? partnerMttd().average_mttd_minutes_current : 0) > (partnerMttd().average_mttd_minutes_previous !== null ? partnerMttd().average_mttd_minutes_previous : 0)"
      [class.down]="(partnerMttd().average_mttd_minutes_current !== null ? partnerMttd().average_mttd_minutes_current : 0) < (partnerMttd().average_mttd_minutes_previous !== null ? partnerMttd().average_mttd_minutes_previous : 0)"
    >
      @if ((partnerMttd().average_mttd_minutes_current !== null ? partnerMttd().average_mttd_minutes_current : 0) < (partnerMttd().average_mttd_minutes_previous !== null ? partnerMttd().average_mttd_minutes_previous : 0)) {
        <span>↓</span>
      }
      @if ((partnerMttd().average_mttd_minutes_current !== null ? partnerMttd().average_mttd_minutes_current : 0) > (partnerMttd().average_mttd_minutes_previous !== null ? partnerMttd().average_mttd_minutes_previous : 0)) {
        <span>↑</span>
      }
      {{ partnerMttd().average_mttd_minutes_pct_change !== undefined ? Math.abs(partnerMttd().average_mttd_minutes_pct_change) : (Math.abs((((partnerMttd().average_mttd_minutes_current !== null ? partnerMttd().average_mttd_minutes_current : 0) - (partnerMttd().average_mttd_minutes_previous !== null ? partnerMttd().average_mttd_minutes_previous : 0)) / (partnerMttd().average_mttd_minutes_previous !== null ? partnerMttd().average_mttd_minutes_previous : 1)) * 100) | number: '1.1-1') }}% vs Last Period
    </div>
    <div class="metric-subtext">Previous: {{ partnerMttd().average_mttd_minutes_previous !== null ? partnerMttd().average_mttd_minutes_previous : 0 }} mins</div>
  </div>
</div>

<kendo-dialog
  *ngIf="showPopup"
  (close)="close()"
  [width]="'95vw'"
  [height]="'90vh'"
  [minWidth]="'800px'"
  [maxWidth]="'1400px'"
>
  <kendo-dialog-titlebar>View Data</kendo-dialog-titlebar>
  <div class="dialog-content">
    <kendo-grid
      class="mxh-80v w-100"
      [filterable]="true"
      [data]="gridService | async"
      [pageable]="{
        buttonCount: 5,
        info: true,
        type: 'numeric',
        pageSizes: [25, 50, 100, 200]
      }"
      [pageSize]="gridService.state.take"
      [skip]="gridService.state.skip"
      [(filter)]="gridService.state.filter"
      [loading]="gridService.loading"
      (dataStateChange)="gridService.onStateChange($event)"
      [sort]="this.gridService.state.sort"
      [sortable]="true"
      [resizable]="true"
    >
      <ng-template kendoGridToolbarTemplate>
        <button
          type="button"
          kendoGridExcelCommand
          class="cyflare-btn-secondary"
        >
          Export to Excel
        </button>
      </ng-template>
      <kendo-grid-column
        field="alert_received_on"
        title="Created On"
        [width]="200"
      >
      <ng-template
        kendoGridFilterCellTemplate
        let-filter
        let-column="column"
      >
        <kendo-grid-date-filter-cell
          [column]="column"
          [filter]="filter"
          [operators]="dateFilterOperators"
        ></kendo-grid-date-filter-cell>
      </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        field="case_closed_on"
        title="Closed On"
        [width]="200"
      >
      <ng-template
        kendoGridFilterCellTemplate
        let-filter
        let-column="column"
      >
        <kendo-grid-date-filter-cell
          [column]="column"
          [filter]="filter"
          [operators]="dateFilterOperators"
        ></kendo-grid-date-filter-cell>
      </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        field="case_id"
        title="SOAR ID"
      ></kendo-grid-column>
      <kendo-grid-column
        field="zoho_ticket_number"
        title="Escalated Case #"
      ></kendo-grid-column>
      <kendo-grid-column
        field="event_name"
        title="Event Name"
      ></kendo-grid-column>
      <kendo-grid-column
        field="case_severity"
        title="Priority"
      ></kendo-grid-column>
      <kendo-grid-excel
        fileName="mttdmetricts-data.xlsx"
        [fetchData]="allData"
      ></kendo-grid-excel>
    </kendo-grid>
  </div>
</kendo-dialog>